import { AgeVerificationDokobit } from './components/age-verification-dokobit';
import { AgeVerificationCitadele } from './components/age-verification-citadele';
AgeVerificationDokobit.init();
AgeVerificationCitadele.init();
